import { render, staticRenderFns } from "./AppTextLink.vue?vue&type=template&id=4e912654&"
import script from "./AppTextLink.vue?vue&type=script&lang=js&"
export * from "./AppTextLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports